import { call, put, takeEvery } from 'redux-saga/effects';
import ActionTypeConstants from 'helpers/ActionTypeConstants';
import Cookies from 'js-cookie';
import { actionApiCall } from 'helpers/api/ApiCalls';

// const getUserOrgs = state => state.UserOrgSiteReducer;

/**
 * Initially get user by token. UI will be blocked until we have a response here.
 * Logic is the same as in UserLoginForm submission
 * 
 * calling this on every page from Root.js
 * 
 */
function* authGetUserSaga() {
  try {

    // Check if we're logged and we have at least selected org - via cookie
    const isLogged = yield Cookies.get('isLogged');
    const org = yield Cookies.get('org');
    const site = yield Cookies.get('site') || false;

    if (isLogged) {
      // load orgs for user
      yield put({ type: ActionTypeConstants.LOAD_USER_ORG_SITE });

      // get use profile
      const apiResponse = yield call(actionApiCall, {
        actionType: ActionTypeConstants.LOAD_USER_SETTINGS_FORM,
        data: {}
      });

      if (isLogged && apiResponse.res.data.response === 200) {
        // it's all good, we can login
        const { data } = apiResponse.res.data;

        let is_admin = false;
        let is_super = false;
        let is_officer = false;
        let is_org_admin = false;
        let is_site_admin = false;
        let is_org_admin_label = false;
        // check if we're admin or super for selected org/site
        if (data.role) {
          let selected_roles = {};
          data.role.forEach(role => {
            if (role.organization === `${org}`) {
              // selected_roles = role;
              if (role.site !== "*" && site) {
                if (role.site === `${site}`) {
                    selected_roles = role;
                    if (role.is_admin === "t") {
                      selected_roles.is_site_admin = "t";
                    }
                }
              }
              if (role.site === "*") {
                selected_roles = role;
                selected_roles.is_org_admin = "t";
              }
            }
          });

          is_admin = selected_roles.is_admin === "t" ? true : false;
          is_super = selected_roles.is_super === "t" ? true : false;
          is_officer = selected_roles.is_officer === "t" ? true : false;
          // is_org_admin = selected_roles.is_org_admin === "t" ? true : false;
          // is_site_admin = selected_roles.is_site_admin === "t" ? true : false;
          is_org_admin = ((selected_roles.is_admin === "t" || selected_roles.is_org_admin === "t") && !site) ? true : false;
          is_site_admin = ((selected_roles.is_admin === "t" || selected_roles.is_site_admin === "t") && site) ? true : false;
          is_org_admin_label = selected_roles.is_org_admin === "t" ? true : false;
        }

        yield put({
          type: ActionTypeConstants.SET_USER_ORG_SITE_SUCCESS,
          payload: {
            selected: {
              org,
              site,
              is_admin,
              is_super,
              is_officer,
              is_org_admin,
              is_site_admin,
              is_org_admin_label,
            }
          }
        });

        yield put({
          type: ActionTypeConstants.AUTH_LOGGED_IN_SUCCESS,
          payload: data
        });

      } else {
        // not having required data
        // redirect to login
        yield put({ type: ActionTypeConstants.AUTH_LOGGED_OUT_SUCCESS });
      }

    } else {
      yield put({ type: ActionTypeConstants.AUTH_LOGGED_OUT_SUCCESS });
    }

    // start auth check
    // yield put({ type: 'AUTH_CHECK' });

  } catch (error) {
    // Failure
    yield put({
      type: ActionTypeConstants.SHOW_ALERT,
      payload: {
        message: "An issue occurred while getting profile",
        color: "danger"
      }
    });
  }
}

export default function* () {
  yield takeEvery(ActionTypeConstants.AUTH_GET_USER, authGetUserSaga);
}
